import CONVERT_LANGUAGE_LABELS from '@configs/language/convertButton';
import COUNTRIES_NAMES from '@configs/language/countries/countriesNames';
import MODAL_WELCOME_NEWS_LABELS from '@configs/language/modalWelcomeNews';
import PAYMENT_REASONS from '@configs/language/paymentReasons';
import SECURITY_TWO_FACTOR_LANGUAGE_LABELS from '@configs/language/securityTwoFactor';
import WOO_MOMENTS_LANGUAGE_LABELS from '@configs/language/wooMoments';
import FILE_INPUT_LABELS from '@efex-components/EfexDS/FileInput/FileInput.translations';
import CHINA_PAYMENT_LABELS from '@efex-components/chinaPayments/translations/chinaPayment.translations';
import PROMOTER_RATES_TABLE_LABELS from '@efex-components/navbar/components/PromoterRates/translations';
import ADD_FUNDS_NEW_LABELS from '@efex-components/payables/addFundModal/translations/AddFundsNew.translations';
import SAVINGS_EXPORTER_LABELS from '@pages/SavingsCalculator/translations/savings.translations';
import APPROVE_BENEFICIARY_LABELS from '@pages/approveBeneficiary/translations/approveBeneficiary.translations';
import NEW_WALLET_MODAL_LABELS from '@pages/dashboard/components/NewWalletModal/translations/NewWalletModal.translations';
import PAYMENT_LINK_BUTTON_LABELS from '@pages/dashboard/components/PaymentLinkButton/translations/PaymentLinkButton.translations';
import LOAD_MFE_ERROR_LABELS from '@pages/ecosystem/LoadError/LoadError.translations';
import REQUEST_PAYMENT_FEATURE_LABELS from '@pages/ecosystem/PaymentLink/RequestPaymentFeature/translations/RequestPaymentFeature.translations';
import INACTIVE_USER_LABELS from '@pages/inactiveUser/translations/inactiveUser.translations';
import LENDING_EXPORTER_LABELS from '@pages/lending/translations/Exporter.translations';
import LENDING_LABELS from '@pages/lending/translations/Lending.translations';
import MANUAL_PAYMENT_BUTTON_LABELS from '@pages/manualPaymentButton/translations/manualPaymentButton.translations';
import LIFE_PROOF_LABELS from '@pages/onboarding/USA/steps/StakeHolders/components/form/components/lifeProof/lifeProof.translations';
import PAY_FORWARDS_LANGUAGE_LABELS from '@pages/payables/translations/payForwards.translations';
import TEAM_LABELS from '@pages/profile/myTeam/translations/TeamTranslations';
import REQUEST_TERMS_LABELS from '@pages/requestTerms/translations/requestTerms.translations';
import CREATE_TEAM_MEMBER_CONTINUE_BAR_LABELS from '@pages/teamMember/addTeamMember/translations/ContinueBar.translations';
import EDIT_TEAM_MEMBER_LABELS from '@pages/teamMember/editTeamMember/translations';
import TRANSACTIONAL_PROFILE_LABELS from '@pages/transactionalProfile/translations/transactionalProfile.translations';
import TRANSFER_DETAILS_LABELS from '@pages/transferDetails/translations';
import COLLECT_LOCAL_PAY_LABELS from '@/modules/receivables/components/collectPayLocalCurrencie/translations/CollectLocalPay.translations';
import AUTH_LANGUAGE from '@/layout/shared/translations/auth.translations';
import LOGIN_LABELS from '@/layout/login/translations/login.translations';
import { Country, Language } from '../configs/language';
import RECEIVABLES_LANGUAGE_LABELS from '../configs/language/ReceivableLenguage';
import ACTIVATE_ACCOUNT_LANGUAGE_LABELS from '../configs/language/activateAccount';
import COUNTRY_TRANSLATE_LABELS from '../configs/language/countriesTranslations';
import CREATE_CONTACT_LANGUAGE_LABELS from '../configs/language/createContact';
import DELETE_CONTACT_LANGUAGE_LABELS from '../configs/language/deleteContact';
import DEVELOPERS_TRANSLATIONS from '../configs/language/developersTranslations';
import ERROR_CODES_LANGUAGE_LABELS from '../configs/language/errorCodes';
import FOOTER_LANGUAGE_LABELS from '../configs/language/footer';
import ACTIVATE_INVOICE_LABELS from '../configs/language/invoiceView';
import ONBOARDING_USA_LANGUAGE_LABELS from '../configs/language/onboardingRegistration/onboardingRegistration';
import ONBOARDING_LANGUAGE_LABELS from '../configs/language/onboardingTutorial';
import PAYABLES_LANGUAGE_LABELS from '../configs/language/payableLanguage';
import PAYMENT_INVOICE_LANGUAGE_LABELS from '../configs/language/paymentInvoice';
import PROFILE_LANGUAGE_LABELS from '../configs/language/profileLanguage';
import RECEIVABLES_VIEW_LABELS from '../configs/language/receivables';
import REGISTER_LANGUAGE_LABELS from '../configs/language/registerUser';
import REGISTER_MEXICO_LANGUAGE_LABELS from '../configs/language/registerUserMexico';
import SESSION_TIMEOUT_LANGUAGE_LABELS from '../configs/language/sessionTimeout';
import BASE_LANGUAGE_LABELS from '../configs/language/statesTranslations';
import REFERRAL_LANGUAGE_LABELS from '../configs/language/validateReferral';
import WALLETS_LANGUAGE_LABELS from '../configs/language/wallets';

export const COUNTRY_LANGUAGE: Record<Country, Language> = {
  MX: 'ES' as const,
  USA: 'EN' as const,
  COL: 'ES' as const,
};
export const LANGUAGE_COUNTRY = {
  [COUNTRY_LANGUAGE.MX]: 'MX' as const,
  [COUNTRY_LANGUAGE.USA]: 'USA' as const,
  [COUNTRY_LANGUAGE.COL]: 'COL' as const,
};

export const LANGUAGES = {
  EN: 'EN',
  ES: 'ES',
};

export const LANGUAGES_LOWERCASE = {
  en: 'en',
  es: 'es',
};

export enum LanguageFullNameEnum {
  ES = 'Español',
  EN = 'English',
}

export type CountryLanguage = keyof typeof COUNTRY_LANGUAGE;
const leng = {
  current: 'ES',
  EN: {
    month: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    mexico: 'Mexico',
    usa: 'United States',
    col: 'Colombia',
    br: 'Brazil',
    other: 'Other countries',
    provider: 'VENDOR',
    client: 'CLIENT',
    natural_person: 'NATURAL PERSON',
    entity: 'Entity',
    mandatory: 'mandatory',
    andConnector: 'and',
    orConnector: 'or',
    instructions: 'Instructions',
    beneficiary: 'Beneficiary',
    beneficiary_address: 'Beneficiary address',
    bank: 'Bank',
    bank_address: 'Bank address',
    account_number: 'Account number',
    routingNumber: 'Routing number (for domestic wires)',
    accountClabe: 'Account CLABE',
    intermediary_bank: 'Intermediary bank',
    transferID: 'Transfer ID',
    swift_code: 'Swift code',
    clabe: 'CLABE',

    choose: 'Choose',
    selectClient: 'Select client',
    selectBusiness: 'Select contact',
    underRevision1:
      'Your account is under revision and this process can take between 2-3 business days to review.',
    underRevision2: 'We will notify you once this is complete.',

    specialCharValidation:
      'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character',
    alphabeticValidation: 'Must Contain alphabetics Characters',
    firstNameValidation: 'The First name field is required',
    lastNameValidation: 'The Last name field is required',
    completeNameValidation: 'The Complete name field is required',
    companyNameValidation: 'The Company name field is required',
    dateOfBirthValidation: 'The Birthdate field is required',
    countryOriginValidation: 'The Country field is required',
    roleValidation: 'The Role field is required',
    emailValidation: 'The Role field is required',
    phoneValidation: 'The phone field is required',
    passwordValidation: 'The Password field is required',
    businessNameValidation: 'The Contact Name is required',
    rfcValidation: 'The RFC is required',
    minChars9: 'Min 9',
    maxChars15: 'Max 15',
    clabeValidation: 'Must have the correct number of digits',
    clabeValidationMore: 'The number exceeds the correct digits of an account',
    accountNumberValidationUS:
      'This number should have between 5 and 17 digits',
    clabeUnsupportedBank: 'Bank not supported at the moment',
    clabeUnsupportedBankSpecific: '{{bankName}} is not supported at the moment',
    defaultError: 'The field is required',
    maxLength150Characters: 'Max 150 characters',
    maxLength100Characters: 'Max 100 characters',
    MaxLengthCharacters: 'Max {{max}} characters',
    dateIsNot18YearsOld: 'The date of birth must be at least 18 years old',
    onlyNumbersAndLetters: 'Only numbers and letters are allowed',
    websiteError: 'please enter a valid URL',
    backBtn: 'Back',

    optional: 'Optional',
    required: 'Required',
    continue: 'Continue',
    depositMade: 'Deposit made',
    confirmPayment: 'Confirm payment',
    bankDepositMessage:
      'Please click “Confirm Payment” to finalize the scheduling of the transaction.',
    back: 'Back',
    cancel: 'Cancel',
    verify: 'Verify',
    done: 'Done',
    pay: 'Pay',
    reject: 'Reject',
    close: 'Close',
    save: 'Save',
    verifyPassword:
      'Need to verify your password, input your password and click on verify',
    newPayment: 'New Payment',
    configureNewTransfer: 'Configure another transfer',
    transferMoney: 'Transfer Money',
    addClient: 'Add Client',
    addBusinessTitle: 'Who will you send the request to?',
    addBusiness: 'Add Contact',
    paymentSuccess: 'Success!',
    paymentSuccessAnalyst: 'Transfer configured',
    paymentSuccessAnalystMessage:
      'The approvers will have 3 hours to approve this payment. After that time, they will be shown the current exchange rate when they approve it.',
    waitingTransfer: 'Waiting Transfer',
    paymentError: 'Payment could not be completed',
    paymentErrorMessage: 'Please contact us at',
    paymentErrorMessage1:
      'in order to give you more information and help you process this payment.',
    paymentNotProcessed: 'Payment Not Processed',
    paymentNotProcessedMessage:
      'You can contact us for more information through: ',
    programmedPayment: 'Waiting for funds',
    paymentInProgress: 'Payment in Progress',
    schedulePaymentInProgress: 'Successful scheduled payment',
    schedulePaymentAnalyst: 'Future transfer configured',
    paymentInProgressMessage:
      'Your payment is in process, we will notify you when the process is complete.',
    paymentMethods: 'Payment Methods',
    textAlertPaymentMethod:
      'To validate your shipment, the payment must be in the name of your company and not third parties',
    noAdditionalCost: 'No additional cost',
    balanceYourAccount: 'Use the balance from your EFEX account',
    zeroCostInMinutes: 'Zero cost and in minutes',
    since: 'Since',
    fromYourBank: 'From your bank',
    schedulePayment: 'Program a payment for the Future',
    choosePaymentDate: 'Choose the payment date',
    forwardMessage: 'When executing this forward you agree on two conditions',
    forwardMessage1:
      'The chosen date is the day on which the agreed payment will be executed. Please load the corresponding funds before the deadline.',
    forwardMessage2:
      'You will have to deposit 5% of the funds for the forward in the next 24 hours for this operation to remain valid.',
    forwardButton: 'Schedule payment',
    forwardTitle: 'Forward: protect your money from exchange rate volatility.',
    parcialPaymentAmount: 'Amount',
    schedulePaymentTitle: 'Schedule your payment',
    scheduleConfigureTitle: 'Schedule your transfer',
    scheduleNewPayment: 'Schedule another transfer',
    parcialPaymentTitle: 'Forward Blocked Balance',
    parcialPaymentPercentage: 'Percentage',
    forwardWarning:
      'If the funds are not received by the indicated date: {{date}}, any fluctuation in the exchange rate occurring between the date the forward contract was booked and the scheduled execution date will be charged. ',
    forwardWarning2:
      'Please load the corresponding funds before or on the date of the deadline.',
    domesticTransferYourBank:
      'Close an exchange rate and then deposit from your bank.',
    uniqueCode: 'Unique code',
    purchaseInformation: 'Purchase Information',
    fromAccount: 'From Account',
    fromBank: 'From Bank',
    dateTransaction: 'Date of Transaction',
    selectOption: 'Select an option',

    itemsTitle: 'Items',
    item: 'Item',
    addNewItem: 'ADD New Item',
    qty: 'qty',
    price: 'Price',
    salesTax: 'Sales Tax',
    paymentTerm: 'Payment Term',
    city: 'City',
    state: 'State',
    send: 'Send',
    generateLink: 'Generate',
    clientEmail: 'Client Email',
    businessEmail: "Contact's Email",
    newClient: 'New Client',
    newBusiness: 'New Contact',
    clientNumber: 'New Number',
    clientNumber2: 'Company New Number (optional)',
    businessNumber: 'Company Phone',
    companyNumber: 'Company Number',
    address1: 'Address line 1',
    address2: 'Address line 2',
    mxAddressLine1: 'Street',
    externalNumber: 'External number',
    internalNumber: 'Internal number (optional)',
    cityText: 'City',
    stateText: 'State',
    postCode: 'Zip code',
    taxID: 'Tax ID',
    bankAccount: 'Bank Account Number',
    identificationNumber: 'Identification number',
    transferMethod: 'Transfer Method',
    transferMethodInfo:
      'WIRE: Funds may take between 1 to 3 hours to be credited (Depends on the FED banking cutoff times).\nACH: Funds may take between 1 to 2 days to be credited.',
    identificationUS: 'Tax ID',
    identificationMX: 'RFC',
    identificationCOL: 'ID',
    bankName: 'Bank Name',
    namesText: 'Names',
    firstName: 'First Name',
    lastName: 'Last Name',
    birthDate: 'Birth Date',
    email: 'Email',
    password: 'Password',
    clickHere: 'Click Here',
    register: 'Register',
    login: 'Login',
    personalInformation: 'Personal Information',
    generalInformation: 'Information General',
    companyInformation: 'Company Information',
    additionalInformation: 'Additional Information',
    loginMsgError:
      'We don’t see that you have an account associated with this email. Please register to create an EFEX Account',
    country: 'Country',
    isNewUserPerson: 'Person',
    isNewUserCompany: 'Company',
    typeOfBusiness: 'Company Type',
    textTermCondition: 'if you continue you will acepted the',
    termCondition: 'Terms & Conditions',

    companyName: 'Company name',
    nickName: 'User name',
    role: 'Job Title',

    completeName: 'Complete Name',
    documentNumber: 'Document Number',
    roleTrack: 'Role',
    uploadDocumentMessage: 'Click or drop your',
    successUpload: 'Success on load',
    failUpload: 'Error on load',

    generalDocument: 'GENERAL DOCUMENT',
    einDocument: 'EIN DOCUMENT',
    ownerDocument: 'PROPERTY DOCUMENT',
    goodReputation: 'CERTIFICATE REPUTATION',
    passport: 'PASSPORT',
    residency: 'RESIDENCY',
    clear: 'Clear',

    attachDocument: 'Attach Document',
    ineFront: 'Official ID - Front',
    ineBack: 'Official ID - Back',
    shareholder: 'Are you Shareholder of more that 25% of the company?',
    tpIncome1: '0 to 50',
    tpIncome2: '51 to 100',
    tpIncome3: '101 to 500',
    tpIncome4: 'More than 500',
    accNumber1: '0 to 10',
    accNumber2: '11 to 50',
    accNumber3: '51 to 100',
    accNumber4: 'More than 100',
    operationNumber: 'More than $1,000,000.00',
    accountType: 'Account Type',
    documentType: 'Document type',
    checkingsAccount: 'Checkings Account',
    CCType: 'Citizenship Certificate',
    CEType: 'Immigration ID',
    NITType: 'Tax Identification Number',
    PASSType: 'Passport',
    PEPType: 'Special Residence Permit',
    ccValue: 'ID (CC or NIT)',
    savingsAccount: 'Savings Account',
    SSNType: 'Social Security Number',
    PssType: 'Passport',
    PASS: 'Passport',
    Provider: 'Provider',
    Client: 'Client',
    Creditor: 'Creditor',
    Debtor: 'Debtor',
    Subsidiary: 'Subsidiary',
    Headquarters: 'Headquarters',
    Others: 'Others',

    businessName: 'Legal Contact Name',
    website: 'Website',
    rfc: 'RFC',
    folioNumber: 'FOLIO NUMBER',
    digitalSignature: 'DIGITAL SIGNATURE',
    consularRegistration: 'CONSULAR REGISTRATION',
    proofOfLiveness: 'PROOF OF LIVENESS',
    proofOfAddress: 'PROOF OF ADDRESS',

    dontforget: "Don't forget to include ",
    transactionNotes: ' on your bank payment.',
    accountBalanceAdd: 'Funds to Add',
    accountBalanceAdded: 'Funds Added',
    accountBalance: 'Account Balance',
    domesticWire: 'Domestic Wire',
    ACH: 'ACH',
    accountBalanceMessage:
      'The transfer will be added a couple of minutes after you receive the transfer from any other bank.',
    accountBalanceMessageTwo:
      'It may take 1 to 2 days for the funds to be credited.',
    accountBalanceAddedMessage: 'The funds will be added a couple of minutes',
    accountBalanceErrorMessage: 'We had a problem processing your order',
    clientBalance: 'Client',
    exchangeRate: 'Exchange Rate',
    youSend: 'You send',
    placeholderSendDollars: 'US Dollars',
    shippingCost: 'Shipping Cost',
    shippingType: 'Shipping Type',
    yourContactReceives: 'Your contact receives',
    receivables: 'Payments in',
    receivablesSubmenuTitle: 'Manage your payments in',
    newInvoice: 'Request Payment',
    newInvoiceLink: 'Generate Payment Link',
    newInvoiceButton: 'Request payment EFEX user',
    newAccountNumberButton: 'My Account Number',
    optionsContactsLabel: 'Your contacts',
    optionsUsersLabel: 'EFEX users',
    accountStatus: 'Account Status',
    cashStatement: 'Statements',
    incomeStatement: 'Income Statement',
    selectTheAirDate: 'Select the air date',
    yourAccountStateGenerated: 'Your account statement has been generated',
    type: 'Type',
    typeTransaction: 'Type of Transaction',
    transactionCode: 'Movement',
    incomeAccount: 'Statements',
    issueMonth: 'Issue Month',
    downloadPDF: 'Download PDF',
    pdf: 'PDF',
    errorDownload: 'Error downloading the document, please try again later',
    excel: 'Excel',
    generate: 'Generate',
    payables: 'Payments out',
    payablesSubmenuTitle: 'Manage your payments out',
    deposits: 'My accounts',
    addFunds: 'Add Funds',
    copLabelTax: 'This payment includes the cost of the GMF tax (4x1000)',
    addFundsDisclaimer:
      'The transfer must be made from the CLABE account registered when creating the account',
    addFundsDisclaimerUSD:
      'To add funds you will need to do a DOMESTIC WIRE from the bank account that you registered on your onboarding',
    addFundsDisclaimerCOP:
      'The transfer must be made from the bank account registered in the creation of the account',
    addFundsWireTransfer:
      'Please send a transfer from your Bank through SPEI to load funds into your EFEX account',
    addFundsWireTransferCol:
      'Please add the amount through the following link:',
    openColLink: 'Open add funds link',
    addFundsWireTransferUSA:
      'Please send a Domestic Wire to this account to add funds to your EFEX account',
    cashOut: 'Cash Out',
    addNewClient: 'Add New Client',
    addNewBusiness: 'Add New Contact',
    noPermissionsClients:
      'Only users with administrator permissions can view and edit contacts for this account',
    makeNewPayment: 'Send Payment',
    configureNewPayment: 'Configure Payment',
    makeNewInvoice: 'Request Payment',
    convert: 'Convert',
    seeDetail: 'See detail',
    viewAll: 'See receipt',
    view: 'View',
    getCheckoutLink: 'Get link',
    payment: 'Payment',
    receipt: 'Receivable',
    paymentLink: 'PaymentLink',
    swift: 'Swift',
    withdrawal: 'Withdrawal',
    search: 'Search',
    filter: 'Filter',
    uuid: 'UUID',
    copyToClipboardMessage:
      'The link has been copied, you can send it by text message or open a new window and paste it to validate the information.',
    clientName: 'Client name',
    RepresentativeName: 'Representative name',
    paymentStatus: 'Payment status',
    dateText: 'Payment Requested',
    paymentSent: 'Payment scheduled',
    transactionType: 'Transaction type',
    viewStatus: 'Receiver Mail',
    depositAmount: 'Amount',
    minAmount: 'Minimum amount {{amount}}',
    amount: 'Amount to pay',
    desAmount: 'Conversion',
    originAmount: 'Origin amount',
    paymentDestiny: 'Destiny',
    fee: 'Fee',
    status: 'Status',
    operationStatus: 'Operation status',
    operationVoucher: 'Receipt of payment',
    shouldArrive: 'Date sent',
    newAccountBalance: 'New account balance',
    scheduledDate: 'Scheduled Date',
    comment: 'Payment concept',
    paymentReason: 'Payment Reason',
    recipientGets: 'How much money do you want to send?',
    realTimeExchange: 'Real time exchange rate',
    finalExchangeRate: 'Final exchange rate',
    mustBeGreaterThan: 'Must be greater than {{rate}}',
    savingRate: 'Saving rate',
    rateSaved: 'Rate saved successfully',
    promoterFee: 'Promoter fee',
    error: 'Error',
    rateMustBe: 'Rate must be {{comparison}} than {{rate}}',
    greater: 'greater',
    lower: 'lower',
    errorLoadingRateInput: 'Error loading rate input',
    GmfFee: 'GMF tax (4x1000)',
    usdFee: 'USD Transfer Fee',
    eurFee: 'EUR Transfer Fee',
    forwardRate: 'Exchange rate:',
    amountToSend: 'If you know how many ',
    amountToSend1: ' the receiver should get, write them down here',
    amountToSend3: 'Recipient will get:',
    amountToSendHelper: 'You cannot send less than $1 {{currency}}',
    amountToConverHelper: 'You cannot convert less than $1 {{currency}}',
    amountConver: 'Amount to convert',
    amountTranfer: 'Amount to send',
    paymentDue: 'Payment Due',
    invoiceNumber: 'Invoice Number',
    detail: 'Detail',
    bankTransfer: 'Deferred Payment',
    gmfTax:
      'This calculation includes de GMF tax in Colombia (mostly known as the “4x1000” tax)',

    clients: 'Clients',
    contacts: 'Contacts',
    security: 'Security',
    balances: 'History of Conversions.',
    balanceMessage: 'History of Conversions.',
    business: 'Business',
    individual: 'Individual',
    contacto1: 'Phone',
    contacto2: 'Contact II',
    address: 'Address',
    registration: 'Registration',
    action: 'Action',

    paymentInstructionTitle:
      'The payment must be made from your bank, follow the instructions below',

    underRevisionTitle: 'Your account is under review',
    underRevisionDes:
      "Don't worry, you can close this window and we will notify you via email when it's ready.",
    underRevisionDesv2:
      "Your account is still under review, this usually takes 12 to 24 hours. Don't worry,",
    underRevisionDesv2USA:
      "Your account is still under review, this usually takes 2 days. Don't worry,",
    underRevisionSubDesv2: "we will notify you via email as soon as it's ready",
    underRevisionContact: 'If you have any questions, please write to us at ',

    mailNotRegister:
      'The email you have entered does not have an EFEX account.',
    ThanksForTrustingUs: 'Thanks for trusting us!',
    accountCompleteRegister:
      'When creating your account, an email was sent with the necessary requirements so that you can continue with this process.',
    btnCompleteRegister: 'Complete Registration',
    textSearchEmail: 'Search by name, email or company name',
    textSearchNotFound: "There's no results for your search",
    mostUsed: 'Most used',
    requiredField: 'This field is required',
    repeatedEmail: 'The email is already registered',
    repeatedIdentification: 'The identification number is already registered',
    validateEmail: 'The email is not valid',
    validatePhone: 'Phone number is not valid',
    insufficientBalance: 'You do not have enough balance in your wallet',
    ...PROFILE_LANGUAGE_LABELS.EN,
    edit: 'Edit',
    update: 'Update',
    buy: 'Buy USD',
    sell: 'Sell USD',
    missingDataReceivablesTitle: 'No receivables',
    missingDataPayablesTitle: 'No payables',
    missingDataClientsTitle: 'No clients',
    missingDataBalancesTitle: 'No history of conversions.',
    missingDataReceivablesText: 'All receivables will be located here.',
    missingDataPayablesText: 'All payables will be located here.',
    missingDataClientsText: 'All clients will be located here.',
    missingDataBalancesText:
      'Your history of conversions will be located here.',
    ...RECEIVABLES_LANGUAGE_LABELS.EN,
    sellUSD: 'Dollars I want to sell USD',
    buyMXN: 'Mexican pesos I want to buy MXN',

    kybStepOneTitle: 'Complete the registration of your company in EFEX',
    kybStepOneTitlePerson:
      'Complete your registration to open an account in EFEX',
    kybStepOneDescription: '',

    kybStepOneFirst:
      'ID from the Legal Representative of the Company (e.g. passport, license, etc)',
    kybStepOneFirstPerson: 'ID of the User (e.g. passport, license, or ID)',
    kybStepOneFirstNote:
      '(Note: Only the Legal Representative with powers will be able to create the account with us).',

    kybStepOneSecond: 'Incorporation Document of the Company.',
    kybIncorporationCertificate: 'Incorporation Certificate of the Company.',
    kybStepOneThird:
      'Proof of Address that is not older than three months, as a requirement for domiciliary validation for both documents',
    formStepOneThird: 'Proof of address',
    kybStepOneNumber: 'Document number',
    kybStepOneUploadDoc: 'Upload Document',
    pleaseYourClabe:
      'Please introduce your CLABE to connect it with your EFEX account',
    pleaseYourAccountNumber:
      'Please introduce your Account Number and Routing Number to connect it with your EFEX account',
    pleaseYourAccountNumberCOL:
      'Please introduce your bank account number to connect it with your EFEX account',

    upload: 'Upload',
    uploadBulkError: 'Failed to upload the document. Please try again later.',
    uploadBulkSuccess:
      'The document has been uploaded successfully and your payments are currently processing.',
    uploadInvoice: 'Upload Invoice',
    uploadInvoiceSendPayment: 'Upload a document/invoice (optional)',
    uploadInvoiceModificationDate: 'Modified',
    uploadInvoiceFileSize: 'Size',
    uploadInvoiceFileSizeExceeded:
      'Your file is larger than 10 Mb, please select a file under 10 Mb',
    sendDoc: 'Send Documents',
    sendBulks: 'Send Bulks',
    note: ' Note',
    goToDashboard: 'Return to the dashboard',
    noteSendBulks:
      'Please download the corresponding excel to send bulk payments internationally to another country. Upload the excel so EFEX can verify the information and process those payments instantly.',
    filename: 'Filename',
    creationDate: 'Creation Date',

    kybStepOneFooterFirst: 'If you have any questions, please write to us at ',
    kybStepOneFooterSecond: 'and we will gladly assist you!',

    kybReview: 'Your account is pending review',
    kybStepTwoTitle: 'Done! Your account is under review',
    kybStepTwoDescriptionOne:
      "We are reviewing your account to ensure everything is in order. Don't worry, ",
    kybStepTwoDescriptionOneUSA:
      "Your account is still under review, this usually takes 2 days. Don't worry, ",
    kybStepTwoDescriptionTwo:
      "we will notify you via email as soon as it's ready. Thank you for your patience!",
    kybStepTwoFooterOne: 'If you have any questions, please ',
    kybStepTwoFooterTwo: ' contact us ',
    kybStepTwoFooterThird: 'at ',
    buyUSD: 'USD I want to buy',
    titleInstructionsMP: 'Follow the instructions to make your payment',
    firstInstructionsMP:
      'Access your bank account from your computer or smartphone.',
    secondInstructionsMP01: 'Place this Clabe account',
    secondInstructionsMP02: 'on behalf of',
    secondInstructionsMP03: 'Bank',
    thirdInstructionsMP01: 'Then, to finish the payment ',
    thirdInstructionsMP02: 'please send a SPEI to the previous CLABE for',
    nvioPagos: 'NVIO Pagos',
    ...ONBOARDING_LANGUAGE_LABELS.EN,
    ...ONBOARDING_USA_LANGUAGE_LABELS.EN,
    ...PROFILE_LANGUAGE_LABELS.EN,
    ...ACTIVATE_ACCOUNT_LANGUAGE_LABELS.EN,
    ...ACTIVATE_INVOICE_LABELS.EN,
    ...REFERRAL_LANGUAGE_LABELS.EN,
    ...PAYABLES_LANGUAGE_LABELS.EN,
    errorRetry: 'Retry again',
    errorRetryMessage: 'An unexpected error occurred',
    serviceUnavailable: 'Service temporarily unavailable',
    tryOrContact: 'Try again later or contact us at',
    plaidTitle: 'Connect your bank',
    wireTitle: 'Continue',
    resetSuccessEmail:
      'We sent you an email to reset your password. If you don’t see it in your inbox please check your spam folder.',
    resetSuccessPassword:
      'Password reset successfully, redirecting to the platform',
    errorGlobalMessage: 'Something went wrong, try again.',
    resetPasswordMessage:
      'If the email exists, we send you a link to reset your password',
    ...PAYMENT_INVOICE_LANGUAGE_LABELS.EN,
    ...BASE_LANGUAGE_LABELS.EN,
    ...CREATE_CONTACT_LANGUAGE_LABELS.EN,
    ...REGISTER_LANGUAGE_LABELS.EN,
    ...COUNTRY_TRANSLATE_LABELS.EN,
    agree: 'Yes',
    disagree: 'No',
    invoiceDetail: 'Receipt',
    paymentConcept: 'Payment concept',
    requestPaymentConcept: 'Request payment concept',
    filterByDate: 'Filter by date',
    startDate: 'Start date',
    endDate: 'End Date',
    addFilters: 'Add Filters',
    hideFilters: 'Remove Filters',
    inpuitFilePlaceholderHeader: 'Drag and drop here or click to upload',
    inpuitFilePlaceholder: 'Upload png, pdf or jpg. Max size 10MB',
    isSingleFileInput:
      'Only one file is allowed, if you need to change it first delete the current one',
    ibanValidation: 'The bank country was updated with the IBAN code',
    ...WALLETS_LANGUAGE_LABELS.EN,
    ...ERROR_CODES_LANGUAGE_LABELS.EN,
    ...SESSION_TIMEOUT_LANGUAGE_LABELS.EN,
    ...DEVELOPERS_TRANSLATIONS.EN,
    ...FOOTER_LANGUAGE_LABELS.EN,
    ...SECURITY_TWO_FACTOR_LANGUAGE_LABELS.EN,
    ...COUNTRIES_NAMES.EN,
    ...RECEIVABLES_VIEW_LABELS.EN,
    ...REGISTER_MEXICO_LANGUAGE_LABELS.EN,
    ...LENDING_LABELS.EN,
    ...LENDING_EXPORTER_LABELS.EN,
    ...DELETE_CONTACT_LANGUAGE_LABELS.EN,
    ...MODAL_WELCOME_NEWS_LABELS.EN,
    ...SAVINGS_EXPORTER_LABELS.EN,
    ...TEAM_LABELS.EN,
    ...CONVERT_LANGUAGE_LABELS.EN,
    ...WOO_MOMENTS_LANGUAGE_LABELS.EN,
    ...PAYMENT_REASONS.EN,
    ...ADD_FUNDS_NEW_LABELS.EN,
    ...INACTIVE_USER_LABELS.EN,
    ...REQUEST_TERMS_LABELS.EN,
    ...COLLECT_LOCAL_PAY_LABELS.EN,
    ...MANUAL_PAYMENT_BUTTON_LABELS.EN,
    ...PAY_FORWARDS_LANGUAGE_LABELS.EN,
    ...TRANSACTIONAL_PROFILE_LABELS.EN,
    ...LOAD_MFE_ERROR_LABELS.EN,
    ...LOGIN_LABELS.EN,
    ...PAYMENT_LINK_BUTTON_LABELS.EN,
    ...REQUEST_PAYMENT_FEATURE_LABELS.EN,
    ...NEW_WALLET_MODAL_LABELS.EN,
    ...EDIT_TEAM_MEMBER_LABELS.EN,
    ...CREATE_TEAM_MEMBER_CONTINUE_BAR_LABELS.EN,
    ...FILE_INPUT_LABELS.EN,
    ...TRANSFER_DETAILS_LABELS.EN,
    ...LIFE_PROOF_LABELS.EN,
    ...AUTH_LANGUAGE.EN,
    ...PROMOTER_RATES_TABLE_LABELS.EN,
    ...APPROVE_BENEFICIARY_LABELS.EN,
    ...CHINA_PAYMENT_LABELS.EN,
  },

  ES: {
    month: [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ],
    mexico: 'México',
    usa: 'Estados Unidos',
    col: 'Colombia',
    br: 'Brasil',
    other: 'Otros países',
    provider: 'Proveedor',
    client: 'Cliente',
    natural_person: 'Persona Natural',
    entity: 'Entidad',
    mandatory: 'obligatorio',
    andConnector: 'y',
    orConnector: 'o',
    instructions: 'Instrucciones',
    beneficiary: 'Beneficiario',
    beneficiary_address: 'Dirección beneficiaria',
    bank: 'Banco',
    bank_address: 'Dirección del banco',
    account_number: 'Número de cuenta',
    routingNumber: 'Número routing (para wires domésticos)',
    accountClabe: 'Cuenta CLABE',
    intermediary_bank: 'Banco intermediario',
    transferID: 'ID de transferencia',
    swift_code: 'Código swift',
    clabe: 'CLABE interbancaria',

    choose: 'Selecciona',
    selectClient: 'Selecciona un cliente',
    selectBusiness: 'Seleccciona un contacto',
    underRevision1:
      'Tú cuenta está bajo revisión y este proceso puede tardar entre 2 y 3 días hábiles en revisarse.',
    underRevision2: 'Te notificaremos una vez que esto esté completo.',

    specialCharValidation:
      'Debe contener 8 caracteres, uno en mayúscula, uno en minúscula, un número y un carácter de caso especial',
    alphabeticValidation: 'Debe contener caracteres alfabéticos',
    firstNameValidation: 'El campo Nombre es obligatorio',
    lastNameValidation: 'El campo Apellido es obligatorio',
    completeNameValidation: 'El campo Nombre Completo es obligatorio',
    companyNameValidation: 'El campo Nombre de la empresa es obligatorio',
    dateOfBirthValidation: 'El campo Fecha de nacimiento es obligatorio',
    countryOriginValidation: 'El campo País es obligatorio',
    roleValidation: 'El campo Rol es obligatorio',
    emailValidation: 'El campo de correo electrónico es obligatorio',
    phoneValidation: 'El campo de teléfono es obligatorio',
    passwordValidation: 'El campo Contraseña es obligatorio',
    businessNameValidation: 'El Nombre Comercial es requerido',
    rfcValidation: 'El RFC es requerido',
    minChars9: 'Min 9',
    maxChars15: 'Max 15',
    clabeValidation: 'Debe tener la cantidad de dígitos correcta',
    clabeValidationMore: 'El número supera los dígitos correctos de una cuenta',
    accountNumberValidationUS: 'Este número debería tener entre 5 y 17 dígitos',
    clabeUnsupportedBank: 'Banco no soportado por el momento',
    clabeUnsupportedBankSpecific:
      '{{bankName}} no está soportado por el momento',
    defaultError: 'El campo es requerido',
    maxLength150Characters: 'Máximo 150 caracteres',
    maxLength100Characters: 'Máximo 100 caracteres',
    MaxLengthCharacters: 'Máximo {{max}} caracteres',
    dateIsNot18YearsOld: 'La edad debe ser de al menos 18 años',
    onlyNumbersAndLetters: 'Solo se permiten números y letras',
    websiteError: 'Por favor introduzca una URL valida',
    backBtn: 'Regresar',
    optional: 'Opcional',
    required: 'Requerido',
    continue: 'Continuar',
    depositMade: 'Depósito realizado',
    confirmPayment: 'Confirmar pago',
    bankDepositMessage:
      'Por favor haz click en confirmar pago para terminar de programar la transferencia.',
    back: 'Regresar',
    cancel: 'Cancelar',
    verify: 'Verificar',
    done: 'Listo',
    pay: 'Pagar',
    reject: 'Rechazar',
    close: 'Cerrar',
    save: 'Guardar',
    verifyPassword:
      'Necesitamos verificar tu contraseña, introduce tu contraseña y haz click en verificar',
    newPayment: 'Nuevo Pago',
    configureNewTransfer: 'Configurar otra transferencia',
    transferMoney: 'Transferir Dinero',
    addClient: 'Agregar Cliente',
    addBusinessTitle: '¿A quién le enviarás la solicitud?',
    addBusiness: 'Agregar Contacto',
    paymentSuccess: '¡Éxito!',
    paymentSuccessAnalyst: 'Transferencia configurada',
    paymentSuccessAnalystMessage:
      'Los aprobadores tendrán 3 horas para aprobar este pago. Pasado ese tiempo se les mostrará el tipo de cambio actualizado al momento que lo aprueben.',
    waitingTransfer: 'Esperando Deposito',
    paymentError: 'El pago no se pudo completar',
    paymentErrorMessage: 'Por favor contáctanos en',
    paymentErrorMessage1:
      'para poder darte más información y ayudarte con el procesamiento del pago.',
    paymentNotProcessed: 'Pago No Procesado',
    paymentNotProcessedMessage:
      'Puede contactarnos para más información a través de: ',
    programmedPayment: 'Esperando Fondos',
    paymentInProgress: 'Procesando Pago',
    schedulePaymentInProgress: 'Pago programado con éxito',
    schedulePaymentAnalyst: 'Transferencia a futuro configurada',
    paymentInProgressMessage:
      'Tu pago se encuentra en proceso te notificaremos cuando se complete el proceso.',
    paymentMethods: 'Métodos de Pago',
    textAlertPaymentMethod:
      'Para validar tu envió el pago tiene que estar a nombre de tu empresa y no de terceros',
    noAdditionalCost: 'Sin costo adicional',
    balanceYourAccount: 'Usa el balance de tu cuenta EFEX',
    zeroCostInMinutes: 'Costo cero y en minutos',
    since: 'Desde',
    fromYourBank: 'Desde tu banco',
    schedulePayment: 'Programar Pago para el Futuro',
    choosePaymentDate: 'Elige la fecha del pago',
    forwardMessage:
      'Al programar un Futuro tienes que cumplir con las siguientes dos condiciones:',
    forwardMessage1:
      'La fecha seleccionada es la fecha en la cual se ejecutará el pago pactado. La carga de fondos debe efectuarse previo al fin del plazo.',
    forwardMessage2:
      'Tendrás que hacer un deposito del 5% de los fondos totales del Futuro en las siguientes 24 horas para mantener esta operación valida.    ',
    forwardButton: 'Programar pago',
    forwardTitle:
      'Futuro: protege tu dinero de la volatilidad en la tasa de cambio.',
    parcialPaymentAmount: 'Monto',
    schedulePaymentTitle: 'Programa tu pago',
    scheduleConfigureTitle: 'Programa tu transferencia',
    scheduleNewPayment: 'Programa otra transferencia',
    parcialPaymentTitle: 'Balance Bloqueado del Forward',
    parcialPaymentPercentage: 'Porcentaje',
    forwardWarning:
      'Si el pago no cuenta con los fondos para la fecha indicada: {{date}}, en caso de no cumplir con el pago de la operación pactada, se deberá cubrir el diferencial entre la tasa de cambio de esa fecha y la pactada inicialmente.',
    forwardWarning2:
      'Por favor carga los fondos correspondientes antes o en la fecha del vencimiento.',
    domesticTransferYourBank:
      'Cierra tasa de cambio y de ahí deposita desde tu banco.',
    uniqueCode: 'Código único',
    purchaseInformation: 'Datos de la compra',
    fromAccount: 'Desde cuenta',
    fromBank: 'Desde Banco',
    dateTransaction: 'Fecha de Transacción',
    selectOption: 'Selecciona una opción',

    itemsTitle: 'Artículos',
    item: 'Artículo',
    addNewItem: 'Agregar Nuevo Artículo',
    qty: 'Cant.',
    price: 'Precio',
    salesTax: 'Impuestos',
    paymentTerm: 'Termino de Pago',
    city: 'Ciudad',
    state: 'Estado',
    send: 'Enviar',
    generateLink: 'Generar',
    clientEmail: 'Email Cliente',
    businessEmail: 'Email Contacto',
    newClient: 'Nuevo Cliente',
    newBusiness: 'Nuevo Contacto',
    clientNumber: 'Telefono de Cliente',
    clientNumber2: 'Telefono de Compañía (opcional)',
    businessNumber: 'Telefono de Contacto',
    companyNumber: 'Telefono de Compañía',
    address1: 'Dirección 1',
    address2: 'Dirección 2',
    mxAddressLine1: 'Calle',
    externalNumber: 'Número exterior',
    internalNumber: 'Número interior (opcional)',
    cityText: 'Ciudad',
    stateText: 'Estado',
    postCode: 'Código postal',
    taxID: 'ID de impuestos',
    bankAccount: 'Número de cuenta bancaria',
    identificationNumber: 'Número de Identificación',
    transferMethod: 'Método de Transferencia',
    transferMethodInfo:
      'WIRE: Pueden tardar entre 1 a 3 horas en verse acreditados los fondos (Depende de los cortes bancarios de la FED).\nACH: Pueden tardar entre 1 a 2 días en verse acreditados los fondos.',
    identificationUS: 'Tax ID',
    identificationMX: 'RFC',
    identificationCOL: 'ID',
    bankName: 'Nombre del Banco',

    namesText: 'Nombre Completo',
    firstName: 'Nombre',
    lastName: 'Apellido',
    birthDate: 'Fecha de Nacimiento',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    clickHere: 'Haz Click Aquí',
    register: 'Registrarme',
    login: 'Entrar',
    personalInformation: 'Información Personal',
    generalInformation: 'Información General',
    companyInformation: 'Información de Compañía',
    additionalInformation: 'Información Adicional',
    loginMsgError:
      'No vemos que tengas una cuenta asociada con este correo electrónico. Regístrese para crear una cuenta Efex',
    country: 'País de Residencia',
    isNewUserPerson: 'Persona',
    isNewUserCompany: 'Empresa',
    typeOfBusiness: 'Tipo de Contacto',
    textTermCondition: 'Si continúas aceptarás los',
    termCondition: 'Términos y Condiciones',

    companyName: 'Nombre de la empresa',
    nickName: 'Nombre de usuario',
    role: 'Rol en la empresa',

    completeName: 'Nombre Completo del representante',
    documentNumber: 'Documento de Identidad',
    roleTrack: 'Posición en la empresa',
    uploadDocumentMessage: 'Haga clic o suelte su',

    generalDocument: 'DOCUMENTO GENERAL',
    einDocument: 'DOCUMENT EIN',
    ownerDocument: 'DOCUMENTO DE PROPIEDAD',
    goodReputation: 'CERTIFICADO DE REPUTATICIÓN',
    passport: 'PASAPORTE',
    residency: 'RESIDENCIA',
    clear: 'Borrar',

    attachDocument: 'Adjuntar Documento',
    ineFront: 'Identificación oficial vigente - Frente',
    ineBack: 'Identificación oficial vigente - Reverso',
    shareholder: '¿Es usted accionista de más del 25% de la empresa?',
    tpIncome1: '0 a 50',
    tpIncome2: '51 a 100',
    tpIncome3: '101 a 500',
    tpIncome4: 'Más de 500',
    accNumber1: '0 a 10',
    accNumber2: '11 a 50',
    accNumber3: '51 a 100',
    accNumber4: 'Más de 100',
    operationNumber: 'Más de $1,000,000.00',
    accountType: 'Tipo de cuenta',
    documentType: 'Tipo de documento',
    checkingsAccount: 'Cuenta de Cheques/Corriente',
    CCType: 'Cédula de Ciudadanía',
    CEType: 'Cédula de Extranjería',
    NITType: 'Número de Identificación Tributaria',
    PASSType: 'Pasaporte',
    PEPType: 'Permiso Especial de Permanencia',
    ccValue: 'ID (CC o NIT)',
    savingsAccount: 'Cuenta Ahorros',
    SSNType: 'Número de Seguridad Social',
    PssType: 'Pasaporte',
    PASS: 'Pasaporte',
    Provider: 'Proveedor',
    Client: 'Cliente',
    Creditor: 'Acreedor',
    Debtor: 'Deudor',
    Subsidiary: 'Subsidiaria',
    Headquarters: 'Matriz',
    Others: 'Otros',

    businessName: 'Nombre Legal',
    website: 'Pagina Web',
    rfc: 'RFC',
    folioNumber: 'NÚMERO DE FOLIO',
    digitalSignature: 'FIRMA DIGITAL',

    consularRegistration: 'MATRICULA CONSULAR',
    proofOfLiveness: 'PRUEBA DE VIDA',
    proofOfAddress: 'COMPROBANTE DE DOMICILIO',

    dontforget: 'No olvides incluir ',
    transactionNotes: ' en tu transerencia bancaria.',
    accountBalanceAdd: 'Fondos por añadir',
    accountBalanceAdded: 'Fondos añadidos',
    accountBalance: 'Saldo de la cuenta',
    domesticWire: 'Domestic Wire',
    Ach: 'ACH',
    accountBalanceMessage:
      'Los fondos se van a cargar unos minutos después de que realices la transferencia desde tu banco.',
    accountBalanceMessageTwo:
      'Los fondos pueden demorar en cargarse 1 o 2 días.',
    accountBalanceAddedMessage: 'Los fondos se van a cargar unos minutos',
    accountBalanceErrorMessage: 'Tuvimos un problema al procesar tu pedido',
    clientBalance: 'Cliente',
    exchangeRate: 'Tipo de cambio',
    youSend: 'Tu envías',
    placeholderSendDollars: 'USD',
    yourContactReceives: 'Tu contacto recibe',
    shippingCost: 'Costo de envío',
    shippingType: 'Tipo de envío',
    receivables: 'Ingresos',
    receivablesSubmenuTitle: 'Gestiona tus cargas de fondos y pagos recibidos',
    newInvoice: 'Solicitar pago',
    newInvoiceLink: 'Generar link de cobro',
    newInvoiceButton: 'Solicitar pago a usuario EFEX',
    newAccountNumberButton: 'Mi Número de Cuenta',
    optionsContactsLabel: 'Tus contactos',
    optionsUsersLabel: 'Usuarios EFEX',
    accountStatus: 'Estado de Cuenta',
    cashStatement: 'Estados de Cuenta',
    incomeStatement: 'Estado de cuenta de Ingresos',
    selectTheAirDate: 'Selecciona la fecha de emisión',
    yourAccountStateGenerated: '¡Tu estado de cuenta ha sido generado',
    type: 'Tipo',
    typeTransaction: 'Tipo de Transacción',
    transactionCode: 'Movimiento',
    incomeAccount: 'Estado de cuenta',
    issueMonth: 'Mes de emisión',
    downloadPDF: 'Descargar PDF',
    pdf: 'PDF',
    errorDownload:
      'Error al descargar el documento, por favor intente más tarde',
    excel: 'Excel',
    generate: 'Generar',
    payables: 'Egresos',
    payablesSubmenuTitle: 'Gestiona los pagos realizados a tus contactos',
    deposits: 'Mis cuentas',
    addFunds: 'Añadir fondos',
    copLabelTax: 'Este pago incluye el costo del impuesto GMF (4x1000)',
    addFundsDisclaimer:
      'La transferencia debe hacerse desde la cuenta CLABE registrada en la creación de la cuenta',
    addFundsDisclaimerUSD:
      'Para cargar fondos deberías hacer un DOMESTIC WIRE desde la cuenta de banco que registraste en EFEX',
    addFundsDisclaimerCOP:
      'La transferencia debe hacerse desde la cuenta bancaria registrada en la creación de la cuenta',
    addFundsWireTransfer:
      'Por favor envía una transferencia desde tu Banco a través de SPEI para cargar fondos en tu cuenta EFEX',
    addFundsWireTransferCol:
      'Por favor añade el monto a través del siguiente link:',
    openColLink: 'Abrir link para agregar fondos',
    addFundsWireTransferUSA:
      'Envíe una transferencia nacional a esta cuenta para agregar fondos a tú cuenta EFEX',
    cashOut: 'Retirar Fondos',
    addNewClient: 'Agregar Nuevo Cliente',
    addNewBusiness: 'Agregar Nuevo Contacto',
    noPermissionsClients:
      'Solo los usuarios con permisos de administrador pueden ver y editar los contactos de esta cuenta',
    makeNewPayment: 'Enviar Pago',
    configureNewPayment: 'Configurar Pago',
    makeNewInvoice: 'Solicitar Pago',
    convert: 'Convertir',
    seeDetail: 'Ver detalle',
    viewAll: 'Ver comprobante',
    view: 'Ver',
    getCheckoutLink: 'Obtener link',
    payment: 'Pago',
    receipt: 'Ingreso',
    paymentLink: 'Link de Pago',
    swift: 'Swift',
    withdrawal: 'Retiro',
    search: 'Búsqueda',
    filter: 'Filtrar',
    uuid: 'UUID',
    copyToClipboardMessage:
      'El link ha sido copiado, puede enviarlo por mensaje de texto o abrir una nueva ventana y pegarlo para validar la información.',
    clientName: 'Nombre del cliente',
    RepresentativeName: 'Nombre de representante',
    paymentStatus: 'Estado de pago',
    dateText: 'Pago Solicitado',
    paymentSent: 'Pago Programado',
    transactionType: 'Tipo de Transacción',
    viewStatus: 'Correo Receptor',
    amount: 'Monto',
    desAmount: 'Monto destino',
    originAmount: 'Monto Origen',
    paymentDestiny: 'Destino',
    depositAmount: 'Monto',
    minAmount: 'Monto mínimo {{amount}}',
    fee: 'Comisión',
    status: 'Estatus',
    operationStatus: 'Estatus de la operación',
    operationVoucher: 'Comprobante de pago',
    shouldArrive: 'Fecha de envío',
    newAccountBalance: 'Nuevo balance',
    scheduledDate: 'Fecha programada',
    comment: 'Concepto de pago',
    paymentReason: 'Razón de Pago',
    recipientGets: '¿Cuánto dinero quieres enviar?',
    realTimeExchange: 'Tasa de cambio en tiempo real',
    finalExchangeRate: 'Tasa de cambio final',
    mustBeGreaterThan: 'Debe ser mayor a {{rate}}',
    savingRate: 'Guardando tasa',
    rateSaved: 'Tasa guardada exitosamente',
    promoterFee: 'Comisión promotor',
    error: 'Error',
    rateMustBe: 'La tasa debe ser {{comparison}} a {{rate}}',
    greater: 'mayor',
    lower: 'menor',
    errorLoadingRateInput: 'Error al cargar la tasa de cambio',
    GmfFee: 'Impuesto GMF (4x1000)',
    usdFee: 'Comisión de envío de USD',
    eurFee: 'Comisión de envío de EUR',
    forwardRate: 'Tasa de cambio:',
    amountToSend: 'Si sabes cuántos ',
    amountToSend1: ' deben llegar, escríbelos aquí',
    amountToSend3: 'El destinatario recibirá:',
    amountToSendHelper: 'No puedes enviar menos de $1 {{currency}}',
    amountToConverHelper: 'No puedes convertir menos de $1 {{currency}}',
    amountConver: 'Monto a convertir',
    amountTranfer: 'Monto a transferir',
    paymentDue: 'Fecha de pago',
    invoiceNumber: 'Número de factura',
    detail: 'Detalle',
    bankTransfer: 'Pago Diferido',
    gmfTax:
      'Este calculo incluye el impuesto GMF en Colombia (conocido como el “4x1000”)',

    clients: 'Clientes',
    contacts: 'Contactos',
    security: 'Seguridad',
    balances: 'Histórico de conversiones.',
    balanceMessage: 'Histórico de mis conversiones',
    business: 'Empresa',
    individual: 'Individuo',
    contacto1: 'Teléfono',
    contacto2: 'Contacto II',
    address: 'Dirección',
    registration: 'Registro',
    action: 'Acción',

    paymentInstructionTitle:
      'El pago debe ser realizado desde tu banco, sigue las siguientes instrucciones',

    underRevisionTitle: 'Tú cuenta está bajo revisión',
    underRevisionDes:
      'No te preocupes, puedes cerrar esta ventana y te avisaremos por correo electrónico cuando esté lista.',
    underRevisionDesv2:
      'Tú cuenta aún está bajo revisión, esto generalmente toma de 12 a 24 horas. No te preocupes,',
    underRevisionDesv2USA:
      'Tú cuenta aún está bajo revisión, esto generalmente toma 2 díass. No te preocupes,',
    underRevisionSubDesv2:
      'te notificaremos por correo electrónico tan pronto como esté lista. ¡Gracias por tu paciencia!',
    underRevisionContact:
      'Si tienes alguna pregunta, por favor contáctanos por',

    mailNotRegister:
      'El correo electrónico que has ingresado no tiene una cuenta de EFEX.',
    ThanksForTrustingUs: 'Gracias por confiar en nosotros!',
    accountCompleteRegister:
      'Al crear tu cuenta se envió un correo con los requisitos necesarios para que puedas seguir con este proceso.',
    btnCompleteRegister: 'Finalizar Registro',
    textSearchEmail: 'Busca por nombre, email o nombre de compañía',
    textSearchPostalCode: 'Busca tu código postal',
    textSearchNotFound: 'No hay resultados para su búsqueda',
    mostUsed: 'Más utilizadas',
    requiredField: 'Este campo es requerido',
    repeatedEmail: 'El email ya se encuentra registrado',
    repeatedIdentification:
      'El número de identificación ya se encuentra registrado',
    validateEmail: 'El email no es válido',
    validatePhone: 'El número de teléfono no es válido',
    insufficientBalance: 'No tienes saldo suficiente en tu billetera',
    ...PROFILE_LANGUAGE_LABELS.ES,
    edit: 'Editar',
    update: 'Actualizar',
    buy: 'Compra de USD',
    sell: 'Venta de USD',
    missingDataReceivablesTitle: 'No tienes ingresos',
    missingDataPayablesTitle: 'No tienes egresos',
    missingDataClientsTitle: 'No tienes contactos',
    missingDataBalancesTitle: 'No tienes historial de conversiones.',
    missingDataReceivablesText: 'Todos tus ingresos se mostrarán aquí',
    missingDataPayablesText: 'Todos tus egresos se mostrarán aquí',
    missingDataClientsText: 'Tu lista de contactos se mostrará aquí',
    missingDataBalancesText: 'Tu historial de conversiones se mostrará aquí.',
    ...RECEIVABLES_LANGUAGE_LABELS.ES,
    sellUSD: 'Dolares que quiero vender USD',
    buyMXN: 'Pesos mexicanos que quiero comprar',

    kybStepOneTitle: 'Finaliza el registro de tu empresa en EFEX',
    kybStepOneTitlePerson: 'Finaliza tu registro para abrir una cuenta en EFEX',
    kybStepOneDescription: '',

    kybStepOneFirst:
      'identificación oficial vigente del Representante Legal de la Empresa (INE, pasaporte, cédula profesional, cartilla militar, etc)',
    kybStepOneFirstPerson:
      'Identificación oficial vigente del usuario (INE, pasaporte, cédula profesional, cartilla militar, etc)',
    kybStepOneFirstNote:
      '(Nota: Sólo el Representante Legal con poderes podrá crear la cuenta con nosotros).',

    kybStepOneSecond: 'Acta Constitutiva de la empresa.',
    kybIncorporationCertificate: 'Certificado de incorporación de la empresa.',
    kybStepOneThird:
      'Comprobante de domicilio con antigüedad no mayor a 3 meses para validación domiciliaria de ambos.',
    formStepOneThird: 'Comprobante de domicilio',
    kybStepOneNumber: 'Número de documento',
    kybStepOneUploadDoc: 'Subir Documento',
    pleaseYourClabe:
      'Por favor introduce tu CLABE interbancaria para conectarla con tu cuenta EFEX',
    pleaseYourAccountNumber:
      'Por favor introduce tu Número de Cuenta y Número Routing para conectarla con tu cuenta EFEX',
    pleaseYourAccountNumberCOL:
      'Por favor introduce tu número de cuenta bancaria para conectarla con tu cuenta de EFEX',

    upload: 'Subir',
    uploadBulkError:
      'No se ha podido cargar el documento. Vuelva a intentarlo más tarde.',
    uploadBulkSuccess:
      'El documento se ha subido correctamente y sus pagos se están procesando.',
    uploadInvoice: 'Subir factura',
    uploadInvoiceSendPayment: 'Subir un documento/factura (opcional)',
    uploadInvoiceModificationDate: 'Modifcado',
    uploadInvoiceFileSize: 'Tamaño',
    uploadInvoiceFileSizeExceeded:
      'Su archivo es mayor a 10Mb, por favor elija un archivo menor a 10 Mb',
    sendDoc: 'Enviar Documentos',
    sendBulks: 'Enviar Pagos',
    note: ' Nota',
    goToDashboard: 'Volver al dashboard',
    noteSendBulks:
      'Por favor descarga el excel para el país al cual deseas enviar los pagos masivos. Una vez completes los datos de todos los beneficiarios a donde quieres realizar los pagos, por favor sube el excel para que podamos procesar las transacciones lo antes posible.',
    filename: 'Nombre del Archivo',
    creationDate: 'Fecha de Creación',

    kybStepOneFooterFirst: 'Si tienes cualquier duda por favor escríbenos a',
    kybStepOneFooterSecond: 'y con gusto te atenderemos',

    kybReview: 'Tu cuenta está pendiente de revisión',
    kybStepTwoTitle: '¡Listo! Tu cuenta está en proceso de revisión',
    kybStepTwoDescriptionOne:
      'Estamos revisando tu cuenta para garantizar que todo esté en orden. No te preocupes, ',
    kybStepTwoDescriptionOneUSA:
      'Tú cuenta aún está bajo revisión, esto generalmente toma 2 días. No te preocupes, ',
    kybStepTwoDescriptionTwo:
      'te notificaremos por correo electrónico tan pronto como esté lista. ¡Gracias por tu paciencia!',
    kybStepTwoFooterOne: 'Si tienes alguna pregunta, por favor',
    kybStepTwoFooterTwo: ' contáctanos ',
    kybStepTwoFooterThird: 'en ',
    buyUSD: 'Dolares que quiero comprar USD',
    titleInstructionsMP: 'Sigue las instrucciones para realizar tu pago',
    firstInstructionsMP:
      'Ingresa a la cuenta de tu banco desde tu computador o smartphone.',
    secondInstructionsMP01: 'Coloca esta cuenta Clabe',
    secondInstructionsMP02: 'a nombre de',
    secondInstructionsMP03: 'Banco',
    thirdInstructionsMP01: 'Luego para terminar el pago ',
    thirdInstructionsMP02: 'favor de enviar un SPEI a la CLABE anterior por',
    nvioPagos: 'NVIO Pagos',
    ...ONBOARDING_LANGUAGE_LABELS.ES,
    ...ONBOARDING_USA_LANGUAGE_LABELS.ES,
    ...PROFILE_LANGUAGE_LABELS.ES,
    ...ACTIVATE_ACCOUNT_LANGUAGE_LABELS.ES,
    ...ACTIVATE_INVOICE_LABELS.ES,
    ...REFERRAL_LANGUAGE_LABELS.ES,
    ...PAYABLES_LANGUAGE_LABELS.ES,
    errorRetry: 'Volver a intentar',
    errorRetryMessage: 'Ocurrió un error inesperado',
    serviceUnavailable: 'Servicio temporalmente no disponible',
    tryOrContact: 'Inténtalo de nuevo más tarde o contáctanos en',
    plaidTitle: 'Conecta tu banco',
    wireTitle: 'Continuar',
    resetSuccessEmail:
      'Te enviamos un correo para que puedas cambiar tu contraseña. Si no lo ves en tu inbox, revisa la carpeta de spam.',
    resetSuccessPassword:
      'Restablecimiento de contraseña con éxito, redireccionando a la plataforma',
    errorGlobalMessage: 'Algo paso, vuelve a intentar.',
    resetPasswordMessage:
      'Si el email existe, le enviamos un enlace para restablecer su contraseña',
    ...PAYMENT_INVOICE_LANGUAGE_LABELS.ES,
    ...BASE_LANGUAGE_LABELS.ES,
    ...CREATE_CONTACT_LANGUAGE_LABELS.ES,
    ...REGISTER_LANGUAGE_LABELS.ES,
    ...COUNTRY_TRANSLATE_LABELS.ES,
    agree: 'Sí',
    disagree: 'No',
    invoiceDetail: 'Comprobante',
    paymentConcept: 'Concepto de pago',
    requestPaymentConcept: 'Concepto de cobro',
    filterByDate: 'Filtrar por fecha',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha final',
    addFilters: 'Agregar Filtros',
    hideFilters: 'Quitar Filtros',
    inpuitFilePlaceholderHeader: 'Arrastra y suelta aquí o haz clic para subir',
    inpuitFilePlaceholder: 'Subir png, pdf o jpg. Tamaño máximo 10MB',
    isSingleFileInput:
      'Solo se permite un archivo, si necesitas cambiarlo primero elimina el actual',
    ibanValidation: 'Se actualizó el país del banco con el código IBAN',
    ...WALLETS_LANGUAGE_LABELS.ES,
    ...ERROR_CODES_LANGUAGE_LABELS.ES,
    ...SESSION_TIMEOUT_LANGUAGE_LABELS.ES,
    ...DEVELOPERS_TRANSLATIONS.ES,
    ...FOOTER_LANGUAGE_LABELS.ES,
    ...SECURITY_TWO_FACTOR_LANGUAGE_LABELS.ES,
    ...COUNTRIES_NAMES.ES,
    ...RECEIVABLES_VIEW_LABELS.ES,
    ...REGISTER_MEXICO_LANGUAGE_LABELS.ES,
    ...LENDING_LABELS.ES,
    ...LENDING_EXPORTER_LABELS.ES,
    ...DELETE_CONTACT_LANGUAGE_LABELS.ES,
    ...MODAL_WELCOME_NEWS_LABELS.ES,
    ...SAVINGS_EXPORTER_LABELS.ES,
    ...TEAM_LABELS.ES,
    ...CONVERT_LANGUAGE_LABELS.ES,
    ...WOO_MOMENTS_LANGUAGE_LABELS.ES,
    ...PAYMENT_REASONS.ES,
    ...ADD_FUNDS_NEW_LABELS.ES,
    ...INACTIVE_USER_LABELS.ES,
    ...REQUEST_TERMS_LABELS.ES,
    ...COLLECT_LOCAL_PAY_LABELS.ES,
    ...MANUAL_PAYMENT_BUTTON_LABELS.ES,
    ...PAY_FORWARDS_LANGUAGE_LABELS.ES,
    ...TRANSACTIONAL_PROFILE_LABELS.ES,
    ...LOAD_MFE_ERROR_LABELS.ES,
    ...LOGIN_LABELS.ES,
    ...PAYMENT_LINK_BUTTON_LABELS.ES,
    ...REQUEST_PAYMENT_FEATURE_LABELS.ES,
    ...NEW_WALLET_MODAL_LABELS.ES,
    ...EDIT_TEAM_MEMBER_LABELS.ES,
    ...CREATE_TEAM_MEMBER_CONTINUE_BAR_LABELS.ES,
    ...FILE_INPUT_LABELS.ES,
    ...TRANSFER_DETAILS_LABELS.ES,
    ...LIFE_PROOF_LABELS.ES,
    ...AUTH_LANGUAGE.ES,
    ...PROMOTER_RATES_TABLE_LABELS.ES,
    ...APPROVE_BENEFICIARY_LABELS.ES,
    ...CHINA_PAYMENT_LABELS.ES,
  },
};

export default leng as unknown as Record<string, any>;
